import { useEffect } from 'react';
import { COLORS, FONT_FAMILY } from '../styles/UISystem';
import { logEvent } from '../services/analytics/eventLogger';
import { hideInstantSplash } from '../utils/instantSplash';

/**
 * Full-screen takeover for converted users. Three variants:
 * - 'conversion': old Safari tab after Anon→Profile conversion
 * - 'qr-guard': returning converted user scans a new QR code
 * - 'install': browser hand-off right after PWA install (pre-OTP) — finish-focused copy
 *   so the user knows to open the app and complete sign-in, not that they're already done
 */
const ConvertedTakeoverScreen = ({ variant, onClear }) => {
  useEffect(() => {
    // Rendered outside ScreenRouter (App.js early return) — hide the splash here
    hideInstantSplash();
    logEvent('session_handoff_takeover_shown', { variant });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const isQRGuard = variant === 'qr-guard';
  const isInstall = variant === 'install';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: COLORS.WHITE,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: FONT_FAMILY,
        zIndex: 1000,
        padding: '0 40px',
      }}
    >
      <img
        src="/apple-touch-icon.png"
        alt="Royale"
        style={{
          width: 72,
          height: 72,
          borderRadius: 16,
          marginBottom: 40,
        }}
      />

      <h1
        style={{
          fontSize: 24,
          fontWeight: 600,
          color: COLORS.DARK_GRAY,
          margin: '0 0 20px 0',
          textAlign: 'center',
          lineHeight: 1.35,
        }}
      >
        {isInstall ? (
          "You've got the app!"
        ) : isQRGuard ? (
          'You have the app!'
        ) : (
          <>
            Your account is now
            <br />
            active in the app
          </>
        )}
      </h1>

      <p
        style={{
          fontSize: 20,
          fontWeight: 400,
          color: COLORS.DARK_GRAY,
          margin: 0,
          textAlign: 'center',
          lineHeight: 1.4,
        }}
      >
        {isInstall ? (
          <>
            Open <span style={{ fontWeight: 600 }}>Royale</span> to finish
            <br />
            signing in
          </>
        ) : (
          <>
            Open <span style={{ fontWeight: 600 }}>Royale</span> on your home
            <br />
            screen or search for it
          </>
        )}
      </p>

      {isQRGuard && onClear && (
        <p
          style={{
            position: 'fixed',
            bottom: 60,
            left: 40,
            right: 40,
            fontSize: 16,
            color: COLORS.MEDIUM_GRAY,
            textAlign: 'center',
            lineHeight: 1.5,
          }}
        >
          If you deleted your account,
          <br />
          click{' '}
          <span
            onClick={onClear}
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            clear
          </span>{' '}
          then scan again
        </p>
      )}
    </div>
  );
};

export default ConvertedTakeoverScreen;
